<template>
  <div>
    <ArrowBack :old-selected-option="oldSelectedOption" @update-old-selected-option="updateOldSelectedOption" />
    <div v-if="isError">
      <TwoTitles :title="valueText['modal_size_reco']['title']" :brand-product="productBrand" />
      <div class="wrapper-size-cleed">
        <div class="wrapper-size-error-cleed">
          {{ valueText['modal_size_reco']['error']['text'] }}
        </div>
        <ButtonSubmit :text="valueText['modal_size_reco']['buttonClose']" class-name="validateButtonSubmitWhite"
          @submitButton="$emit('close')" />
      </div>
    </div>
    <div v-else-if="isLoading" class="loader-center">
      <Loading />
    </div>
    <div v-else>
      <div v-if="selectedOption === '1'">
        <!-- Etape : Choix mode -->
        <TwoTitles :title="valueText['modal_size_reco']['title']" />
        <div class="wrapper-size-cleed">
          <Size v-if="size_list !== ''" class="size-cleed" :selected-option="selectedOption" :mesure="true"
            :i18n="valueText['modal_size_reco']['size']" :mode-select="'normal'" :select-brand="''" :unit-list="unit_list"
            :size-list="size_list" :size-min-max="size_min_max" @update-selected-option="updateSelectedOption"
            @manfield-get-brands="getBrands" />
          <p class="Skip-text" @click="handleSkip">
            {{ valueText['modal_size_reco']['skiptext2'] }}
          </p>
          <!-- <Divider :text="valueText['modal_size_reco']['divider']['or']" /> -->
          <!-- <Brand class="brand-cleed" :i18n="valueText['modal_size_reco']['brand']" @manfield-get-brands="getBrands" @update-selected-option="updateSelectedOption" /> -->
        </div>
      </div>
      <div v-else-if="selectedOption === '2'">
        <!-- Etape : Type de pied -->
        <TwoTitles :title="valueText['modal_size_reco']['title_step_FootType']" />
        <div class="wrapper-size-cleed wrapper-size-flex-cleed">
          <FootType :i18n="valueText['modal_size_reco']['footType']" @manfield-get-sizes="getSizes"
            @update-selected-option="updateSelectedOption" />
        </div>
      </div>
      <div v-else-if="selectedOption === '3'">
        <!-- Etape : Guide mesure -->
        <Title :title="valueText['modal_size_reco']['footGuide']['title']" :level="2" />
        <div class="wrapper-size-cleed wrapper-size-flex-cleed wrapper-size-flex-marg-cleed">
          <FootGuide :i18n="valueText['modal_size_reco']['footGuide']" />
        </div>
      </div>
      <div v-else-if="selectedOption === '5'">
        <!-- Etape : Choix marque -->
        <div class="brand-container">
          <BrandSelect v-if="brands !== ''" :i18n="valueText['modal_size_reco']['brandSelect']" :brands="brands"
            @update-selected-option="updateSelectedOption" />
          <p class="skip-text-margin-top Skip-text" @click="updateSelectedOption('2'); $emit('manfield-get-brands');">
            {{ valueText['modal_size_reco']['skiptext'] }}
          </p>
        </div>
      </div>
      <div v-else-if="selectedOption === '4'">
        <!-- Etape : Affichage résultat -->
        <!-- <TwoTitles :title="valueText['modal_size_reco']['title_step_brand_size']" /> -->
        <div class="wrapper-size-cleed wrapper-size-flex-cleed">
          <ResultSizeReco v-if="result_sizes" :i18n="valueText['modal_size_reco']['resultSizeReco']"
            :result-sizes="result_sizes" :isAvailable="isAvailable" :storeId="this.$store.state.config.storeId" @update-selected-option="updateSelectedOption"
            @reset-submit-button="resetSelectedOption" @closemodal="$emit('close')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/modal/ui/Title.vue";
import Size from "@/components/modal/partials/Size.vue";
// import Brand from "@/components/modal/partials/Brand.vue";
import FootType from "@/components/modal/partials/FootType.vue";
import FootGuide from "@/components/modal/partials/FootGuide.vue";
import ResultSizeReco from "@/components/modal/partials/ResultSizeReco.vue";
import BrandSelect from "@/components/modal/partials/BrandSelect.vue";
// import Divider from "@/components/modal/ui/Divider.vue";
import TwoTitles from "@/components/modal/ui/TwoTitles.vue";
import Loading from "@/components/modal/ui/Loading.vue";
import ButtonSubmit from "@/components/modal/ui/ButtonSubmit.vue";
import store from "../../store";
import ArrowBack from "@/components/modal/ui/ArrowBack.vue";
import { customLogger } from "@/utils";

export default {
  name: "SizeRecommendationShoes",
  components: {
    Size,
    // Brand,
    FootType,
    FootGuide,
    ResultSizeReco,
    BrandSelect,
    // Divider,
    TwoTitles,
    Title,
    ButtonSubmit,
    ArrowBack,
    Loading
  },
  props: {
    valueText: {
      type: Object,
      default: () => { },
    },
    dataLayerPath: {
      type: String,
      default: 'window.dataLayer',
    }
  },
  data() {
    return {
      selectedOption: '1',
      oldSelectedOption: [],
      productBrand: '',
      contentDataLayer: '',
      unit_list: '',
      size_list: '',
      size_min_max: '',
      brands: '',
      result_sizes: '',
      isAvailable: false,
      isError: store.state.user.modal_reco_sizeError,
      isLoading: false,
      details: '', // This will hold the fetched description
      result_details: '', // This will hold the fetched description
      availableSizes: '',
    };
  },
  mounted() {
    this.isLoading = true;
    setTimeout(() => {
      this.startRecoSize();
      this.isLoading = false;
    }, 100);
  },
  methods: {
    resetSelectedOption() {
      this.oldSelectedOption = [];
      this.selectedOption = '1';
      this.isError = false;

      // customLogger("resetSelectedOption");

      store.state.user.modal_reco_sizeContent.foot_size = 0;
      store.state.user.modal_reco_sizeContent.input_size_type = "";
      store.state.user.modal_reco_sizeContent.foot_type = "";
      store.state.user.modal_reco_sizeContent.shoes_brand_select = "";
      store.state.user.modal_reco_sizeContent.result = [];
      store.state.user.modal_reco_sizeContent.result_details = [];

      this.brands = '',
        this.result_sizes = "";
    },
    updateSelectedOption(option) {
      this.isLoading = true;

      this.oldSelectedOption.push(this.selectedOption);

      this.selectedOption = option;


      // // Store the selected size and unit in Vuex
      // store.commit('SET_SELECTED_SIZE', this.selectedSize);
      // store.commit('SET_SELECTED_UNIT', this.selectedUnit);
      // customLogger("set selected size", this.selectedSize);
      // customLogger("store.state.user.modal_reco_size", store.state.user.modal_reco_sizeContent);
      // customLogger("store.state.user.modal_reco_sizeError", store.state.user.modal_reco_sizeContent.result_details);

      // customLogger("selectedOption", this.selectedOption)
      setTimeout(() => {
        this.isLoading = false;
      }, 100);
    },
    handleSkip() {
      this.updateSelectedOption('5');
      this.getBrands();
    },
    updateOldSelectedOption() {
      this.selectedOption = this.oldSelectedOption.pop();
    },
    async startRecoSize() {
      try {
        // récupération du datalayer avec le path
        var dataLayer = eval(this.dataLayerPath);

        if (dataLayer !== undefined) {
          let dataLayerBrand = dataLayer.brand;
          this.productBrand = dataLayerBrand;

          this.contentDataLayer = dataLayer;
          this.storeDataLayer();
          if(store.state.config.storeId === "33"){
            this.getDetails();
          }
          

          if (store.state.user.modal_reco_sizeContent === undefined) {
            store.state.user.modal_reco_sizeContent = {
              foot_size: 0,
              input_size_type: "",
              foot_type: "",
              shoes_brand_select: "",
              shoes_form: dataLayer.last ? dataLayer.last : "",
              shoes_brand: dataLayer.brand,
              result: []
            }
          } else {
            store.state.user.modal_reco_sizeContent.shoes_form = dataLayer.last ? dataLayer.last : "";
            store.state.user.modal_reco_sizeContent.shoes_brand = dataLayer.brand;
          }
        } else {
          throw "no dataLayer";
        }
      }
      catch (error) {
        customLogger("no dataLayer" + error);
        this.isError = true;
      }
    },
    async storeDataLayer() {
      try {
        let dataLayerContent = this.contentDataLayer;
        let size_list = await this.$store.dispatch('FETCH_SIZE_RECO', { dataLayerContent });
        this.unit_list = Object.keys(size_list.data).map(code => code.toUpperCase());
        this.size_min_max = {
          "CM": [size_list.data.cm.min, size_list.data.cm.max],
          "INCH": [size_list.data.inch.min, size_list.data.inch.max],
        };
        this.size_list = {
          "FR": size_list.data.fr,
          "IT": size_list.data.it,
          "UK": size_list.data.uk,
          "US": size_list.data.us,
        };
      } catch (error) {
        this.isError = true;
        customLogger(error);
      }
    },
    async getBrands() {
      try {
        let dataLayerContent = this.contentDataLayer;
        let brands = await this.$store.dispatch('FETCH_BRANDS', { dataLayerContent });
        if (brands.data.length === 0) {
          this.isError = true;
          customLogger("No brands");
          return;
        }

        // Sorting the brands alphabetically by name, considering potential null or undefined values
        brands.data.sort((a, b) => {
          const nameA = a.brand?.toUpperCase() ?? ''; // handle null or undefined and make comparison case-insensitive
          const nameB = b.brand?.toUpperCase() ?? '';
          return nameA.localeCompare(nameB);
        });

        const brandsArray = brands.data.map((item, index) => ({
          name: item.brand,
          image: item.picture_url,
          selected: index === 0 ? true : false, // consider if there's a specific logic for selecting a brand
          sizes: item.size
        }));

        this.brands = brandsArray;
      } catch (error) {
        this.isError = true;
        customLogger("An error occurred while fetching brands:", error);
      }
    },

    async getSizes() {
      try {
        let dataLayerContent = this.contentDataLayer;
        let size_type = store.state.user.modal_reco_sizeContent.input_size_type;
        let input_size_type = store.state.user.modal_reco_sizeContent.foot_size;
        let foot_size = store.state.user.modal_reco_sizeContent.foot_type;
        let input_brand = store.state.user.modal_reco_sizeContent.shoes_brand_select;
        const availableSizes = this.availableSizes?.length ? this.availableSizes.split('/'): [];
        const detailsdata = store.state.user.modal_reco_sizeContent.result_details;
        const globalSizes = detailsdata?.brand_global_sizes?.length ? detailsdata?.brand_global_sizes?.split('/') : [];

              // If sizes.data.shoes_size is the array that needs to be sorted

        
        let sizes = await this.$store.dispatch('FETCH_SIZES', { dataLayerContent, size_type, input_size_type, foot_size, input_brand });
        customLogger("look here", sizes.data.shoes_size);


        if (sizes.data.shoes_size && Array.isArray(sizes.data.shoes_size)) {
          sizes.data.shoes_size.sort((a, b) => a - b);
          // Filter the array to only have unique values
          sizes.data.shoes_size = sizes.data.shoes_size.filter((value, index, self) => {
            return self.indexOf(value) === index;
          });
          customLogger("length", sizes.data.shoes_size.length);

          if (store.state.config.storeId === "33" && sizes.data.shoes_size.length > 1){
            customLogger("length", sizes.data.shoes_size.length);
          sizes.data.shoes_size = [sizes.data.shoes_size[1]];
        }
        } 


        
        
        if (input_brand === '' && detailsdata?.comment_size === 'Taille grand' && detailsdata?.comment_size !== null && detailsdata?.comment_size !== undefined) {
          for (let i = 0; i < globalSizes.length; i++) {
            if (Math.floor(Number(input_size_type)).toString() === globalSizes[i] ){
              if(input_size_type !== Math.floor(input_size_type)) {
                sizes.data.shoes_size[0] = Math.floor(input_size_type)
              } else {
                sizes.data.shoes_size[0] = globalSizes[i-1]
              }
            }
          }
        }

        if (input_brand === '' && detailsdata?.comment_size === 'Taille petit' && detailsdata?.comment_size !== null && detailsdata?.comment_size !== undefined) {
          for (let i = 0; i < globalSizes.length; i++) {
            if (input_size_type.toString() === globalSizes[i] ){
              sizes.data.shoes_size[0] = globalSizes[i+1]
            }
          }
        }

        if (input_brand === '' && detailsdata?.feet_comment_size === "Pieds fins" && foot_size === 'S' && detailsdata?.feet_comment_size !== null && detailsdata?.feet_comment_size !== undefined) {
            for (let i = 0; i < globalSizes.length; i++) {
              if (input_size_type.toString() === globalSizes[i] ){
              sizes.data.shoes_size[0] = globalSizes[i-1]
           }
          }
        }
        
        if ( sizes.data.shoes_size[0] !== undefined) {
          let normalizedFirstSize = sizes.data.shoes_size[0].toString().replace('.', ',');
          
          if (!availableSizes.includes(normalizedFirstSize)) {
            this.isAvailable = false;

          } else {
            this.isAvailable = true;
          }}
        
        this.result_sizes = sizes.data;
        customLogger("this is the result", this.result_sizes);
        this.result_sizes.no_result = this.result_sizes.shoes_size && this.result_sizes.shoes_size.length === 0;
        if (window.matomoTracker) {
          customLogger("final step modal");
          matomoTracker.trackGoal(10);
          matomoTracker.trackEvent("Site", "Final step modal v3");
        }
      } catch (error) {
        this.isError = true;
        customLogger("Error from getSize:", error);
      }
    },

    async getDetails() {
      try {
        let dataLayerContent = this.contentDataLayer;
        let fetch_details = await this.$store.dispatch('FETCH_DETAILS', { dataLayerContent });
        if (fetch_details) {
          this.result_details = fetch_details;
          store.state.user.modal_reco_sizeContent.result_details = fetch_details;
          // customLogger("state rf", store.state.user.modal_reco_sizeContent.result_details);
          // customLogger("this is the result", this.result_details);
          this.availableSizes = fetch_details.sizes;
          // customLogger("this is the result", this.availableSizes);

        }
      } catch (error) {
        this.isError = true;
        customLogger("An error occurred while fetching details:", error);
      }
    }
  }
};
</script>

<style scoped>
.loader-center {
  display: block;
  margin: auto;
  text-align: center;
}

.wrapper-size-cleed {
  display: grid;
  /* Keeps the display as grid */
  place-items: center center;
  /* Centers children both horizontally and vertically */
  min-height: 510px;
  /* This sets a minimum height for the grid container */
  background-color: #FFFFFF;
  padding: 10px;
}


.wrapper-size-flex-cleed {
  display: flex !important;
}

.wrapper-size-error-cleed {
  display: block;
  margin: auto;
  text-align: center;
  margin-top: 50%;
}

.brand-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.Skip-text {
  text-align: center;
  font-size: medium;
  cursor: pointer;
  max-width: 300px;
  margin: 0;
  text-decoration: underline;
}

.skip-text-margin-top {
  margin: 12px 0px;
}

.wrapper-size-flex-marg-cleed {
  margin-top: 44px !important;
}

@media screen and (max-width: 450px) {
  .wrapper-size-cleed {
    /* min-height: auto !important; */
    padding: 5px !important;
  }
}

.loader-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}</style>